export default __webpack_public_path__ + "static/media/pfp-network-sidebar-icon.8300cef6.svg";